/* eslint-disable */
import React, { Component } from "react";
import * as d3 from "d3";

class VoronoiSuburb extends Component {
  componentDidMount() {
    this.setup();
  }

  componentDidUpdate(prevProps, prevState) {
    this.visComponents = this.makeVisComponents(this.props);
    this.update();
  }

  setup() {
    this.visComponents = this.makeVisComponents(this.props);

    const { height, width, innerMargin } = this.visComponents;

    this.g = d3
      .select(this.svg)
      .append("g")
      .attr(
        "transform",
        `translate(${innerMargin.left} ${innerMargin.top - 10})`
      );

    this.series = this.g.append("g").classed("series", true);
    this.xAxis = this.g.append("g").classed("x-axis axis", true);
    this.yAxis = this.g.append("g").classed("y-axis axis", true);
    this.xLabel = this.g.append("g").classed("x-label label", true);
    this.yLabel = this.g.append("g").classed("y-label label", true);
    this.voronoiGroup = this.g.append("g").classed("voronoi", true);
    this.peakChange = d3.select("#left");
    this.tooltip = d3.select(".voronoi-chart").append("div")
      .classed("tooltip", true)
      .style("opacity",0)

    this.focus = this.g
      .append("g")
      .classed("focus", true)
      .attr("transform", "translate(-100,-100)");

    this.update();
  }

  makeVisComponents(props) {
    const { height, width, area, suburb, area_series } = props;

    const innerMargin = { top: 20, right: 40, bottom: 30, left: 40 };
    const innerWidth = width - innerMargin.left - innerMargin.right;
    const innerHeight = height - innerMargin.top - innerMargin.bottom;

    const dateParser = d3.timeParse("%Y-%m-%d");


    const suburbs = [...new Set(area_series.map(d => d.suburb))];

    const highlighted_suburb = props.suburb;

    const suburb_series = suburbs.map(suburb => {
      let s = {
        name: suburb,
        values: null
      };
      s.values = area_series.filter(d => d.suburb === suburb).map(d => {
        return { suburb: s, quarter: dateParser(d.month), median: +d.median };
      });
      return s;
    });

    const xDomain = [dateParser("2000-01-01"), dateParser("2018-06-01")];
    const yDomain = [
      d3.min(area_series, d => d.median),
      d3.max(area_series, d => d.median)
    ];

    const xScale = d3.scaleTime().domain(xDomain).range([10, innerWidth]);
    const yScale = d3.scaleLinear().domain(yDomain).range([innerHeight, 0]);

    var voronoi = d3
      .voronoi()
      .x(function(d) {
        return xScale(d.quarter);
      })
      .y(function(d) {
        return yScale(d.median);
      })
      .extent([
        [-innerMargin.left, -innerMargin.top],
        [innerWidth + innerMargin.right, innerHeight + innerMargin.bottom]
      ]);

    const line = d3
      .line()
      .curve(d3.curveBasis)
      .x(d => xScale(d.quarter))
      .y(d => yScale(d.median));

    return {
      height,
      width,
      innerMargin,
      innerWidth,
      innerHeight,
      xScale,
      yScale,
      suburb_series,
      line,
      voronoi,
      area_series,
      yDomain,
      highlighted_suburb
    };
  }

  update() {
    this.renderVoronoiLines(this.props);
    this.renderLabel();
    this.renderAxes();
  }

  renderVoronoiLines(props) {
    const {
      suburb_series,
      line,
      voronoi,
      area_series,
      innerWidth,
      innerHeight,
      highlighted_suburb
    } = this.visComponents;

    const dateParser = d3.timeParse("%Y-%m-%d");

    const formatMoney = d3.format(".3s");
    const formatQuarter = d3.timeFormat("%B %Y");

    const xDomain = [dateParser("2000-01-01"), dateParser("2018-06-01")];
    const yDomain = [
      d3.min(area_series, d => d.median),
      d3.max(area_series, d => d.median)
    ];

    const xScale = d3.scaleTime().domain(xDomain).range([10, innerWidth]);
    const yScale = d3.scaleLinear().domain(yDomain).range([innerHeight, 0]);

    const movePaths = d3.transition().duration(500).ease(d3.easeLinear);

    const binding = this.series
      .selectAll("path")
      .data(suburb_series, d => d.name);

    const entering = binding
      .enter()
      .append("path")
      .attr("class", "line")
      .attr("class", d => {
        if (d.name === highlighted_suburb) {
          return "highlighted";
        }
      })
      .attr("suburb", d => d.name);

    binding.merge(entering).transition(movePaths).attr("d", function(d) {
      d.line = this;
      return line(d.values);
    });

    this.series.selectAll("path").style("stroke", d => {
      if (d.name === highlighted_suburb) {
        return "#ff9e39";
      }
    }).style("stroke-width", d => {
      if (d.name === highlighted_suburb) {
        return "2.5px";
      } });

    binding.exit().remove().style("stroke", d => {
      if (d.name === highlighted_suburb) {
        return "#ff9e39";
      }
    });

    this.focus.append("text").attr("y", -10);

    const voronoiBinding = this.voronoiGroup
      .selectAll("path")
      .data(voronoi.polygons(d3.merge(suburb_series.map(d => d.values))));



    const voronoiEntering = voronoiBinding
      .enter()
      .append("path")
      .on("click", (d, i) => {
        this.props.clickSuburb(d.data.suburb.name)
        if (window.innerWidth <= 600) {

          const pageX = d3.event && d3.event.pageX;
          const pageY = d3.event && d3.event.pageY;
          this.tooltip.transition()
            .duration(150)
            .style("opacity", .9);
          this.tooltip.html("<b>" + d.data.suburb.name + "</b>" + "<br/> " 
            + "Month: " + formatQuarter(d.data.quarter)
            +  "<br/>"+ " Median Price($): " + formatMoney(d.data.median)
          )
            .style("left", (pageX < window.innerWidth * 0.5 ? pageX : pageX - 140) + "px")
            .style("top", pageY - 80 + "px");


        }
      });
    if (window.innerWidth > 600) {
      voronoiEntering.on("mouseover", (d) => {
        const pageX = d3.event && d3.event.pageX;
        const pageY = d3.event && d3.event.pageY;
        d3.select(d.data.suburb.line).classed("suburb-hover", true);
        d.data.suburb.line.parentNode.appendChild(d.data.suburb.line);


        this.tooltip.transition()
          .duration(150)
          .style("opacity", .9);

        this.tooltip.html("<b>" + d.data.suburb.name + "</b>" + "<br/> " 
          + "Month: " + formatQuarter(d.data.quarter)
          +  "<br/>"+ " Median Price($): " + formatMoney(d.data.median)
        )
          .style("left", (pageX < window.innerWidth * 0.5 ? pageX : pageX - 140) + "px")
          .style("top", pageY - 80 + "px");

        d3.select("#left").select("text").text("Change!");

      })
        .on("mouseout", (d) => {
          d3.select(d.data.suburb.line).classed("suburb-hover", false);

          this.tooltip.transition()
            .duration(150)
            .style("opacity",0)

        })
    }

    voronoiBinding
      .merge(voronoiEntering)
      .attr("d", d => d ? "M" + d.join("L") + "Z" : null);

    voronoiBinding.exit().remove();

  }

  renderAxes() {
    const {
      xScale,
      yScale,
      innerHeight,
      innerWidth,
      innerMargin,
      height
    } = this.visComponents;

    const xAxis = d3.axisBottom(xScale).ticks(4);
    this.xAxis
      .attr("transform", `translate(0 ${innerHeight + 5} )`)
      .call(xAxis);

    const yAxis = d3.axisLeft(yScale).tickFormat(d3.format(".1s")).ticks(2);

    this.yAxis.call(yAxis);
  }

  renderLabel() {
    const {
      xScale,
      yScale,
      area_series,
      width,
      height,
      innerMargin
    } = this.visComponents;

    this.xLabel.selectAll("text").remove();
    this.yLabel.selectAll("text").remove();

    this.yLabel
      .append("text")
      .attr(
        "transform",
        "translate(" + innerMargin.left + "," + innerMargin.top + ")"
      )
      .style("text-anchor", "start")
      .attr("class", "axis-title")
      .attr("dy", "2em")
      .attr("x", -35)
      .attr("y", -37)
      .text("E-valuer median value ($)")
      .style("font-size", "0.8em")
      .style("font-weight", "100");
  }

  render() {
    const { height, width, area, suburb, peak } = this.props;
    return (
      <div className="voronoi-chart">
        <svg
          height={height}
          width={width}
          ref={svg => {
            this.svg = svg;
          }}
        />
      </div>
    );
  }
}

export default VoronoiSuburb;



// WEBPACK FOOTER //
// ./src/VoronoiSuburb.js